import { AtticLocationKind, AtticMovementKind } from "@dashboard/graphql";
import { type Filters, type Pagination } from "@dashboard/types";
import { withQuery } from "@dashboard/utils/urls";
import urlJoin from "url-join";

export const atticInventorySectionUrlName = "/attic/inventory";

/** The hub: one variant's position, by SKU or scan (`?sku=`). */
export const atticStockLookupPath = `${atticInventorySectionUrlName}/`;
export const atticLocationListPath = urlJoin(atticInventorySectionUrlName, "locations/");
export const atticLocationAddPath = urlJoin(atticLocationListPath, "add");
/** Locations are addressed by code, the barcode's text, not by global id. */
export const atticLocationPath = (code: string) => urlJoin(atticLocationListPath, code);
export const atticLocationUrl = (code: string) => atticLocationPath(encodeURIComponent(code));
export const atticLotListPath = urlJoin(atticInventorySectionUrlName, "lots/");
export const atticLotPath = (id: string) => urlJoin(atticLotListPath, id);
export const atticLotUrl = (id: string) => atticLotPath(encodeURIComponent(id));
export const atticIntakePath = urlJoin(atticInventorySectionUrlName, "intake");
export const atticLedgerPath = urlJoin(atticInventorySectionUrlName, "ledger/");
/** The report: totals and breakdowns by set, condition and location. */
export const atticReportPath = urlJoin(atticInventorySectionUrlName, "report/");

export interface AtticStockLookupUrlQueryParams {
  sku?: string;
}
export const atticStockLookupUrl = (params?: AtticStockLookupUrlQueryParams) =>
  withQuery(atticStockLookupPath, params);

export enum AtticLocationListUrlFiltersEnum {
  parent = "parent",
  kind = "kind",
  query = "query",
}
export type AtticLocationListUrlFilters = Filters<AtticLocationListUrlFiltersEnum>;
export type AtticLocationListUrlQueryParams = Pagination & AtticLocationListUrlFilters;
export const atticLocationListUrl = (params?: AtticLocationListUrlQueryParams) =>
  withQuery(atticLocationListPath, params);

export type AtticLotListUrlQueryParams = Pagination;
export const atticLotListUrl = (params?: AtticLotListUrlQueryParams) =>
  withQuery(atticLotListPath, params);

export enum AtticLedgerUrlFiltersEnum {
  sku = "sku",
  kind = "kind",
  location = "location",
}
export type AtticLedgerUrlFilters = Filters<AtticLedgerUrlFiltersEnum>;
export type AtticLedgerUrlQueryParams = Pagination & AtticLedgerUrlFilters;
export const atticLedgerUrl = (params?: AtticLedgerUrlQueryParams) =>
  withQuery(atticLedgerPath, params);

const LOCATION_KINDS = new Set<string>(Object.values(AtticLocationKind));
const MOVEMENT_KINDS = new Set<string>(Object.values(AtticMovementKind));

/** The kind in the URL, or undefined for anything that is not one of the API's. */
export const parseAtticLocationKind = (kind: string | undefined) =>
  kind && LOCATION_KINDS.has(kind) ? (kind as AtticLocationKind) : undefined;
export const parseAtticMovementKind = (kind: string | undefined) =>
  kind && MOVEMENT_KINDS.has(kind) ? (kind as AtticMovementKind) : undefined;
